export enum AuthorizationPaths {
  login = '/login',
  registerLogin = '/register-login',
  refreshToken = '/refresh-token',
  logout = '/logout',
}
